import axios from 'axios';
import {p60Constants} from '../constants';

export function getP60(){
  return function(dispatch){
    dispatch({type:p60Constants.GET_REQUEST});
    axios.get('/p60')
      .then((result)=>{
        dispatch({type: p60Constants.GET_SUCCESS, payload: result.data});
      })
      .catch((err)=>{
        dispatch({type:p60Constants.GET_FAILURE, error: err});
      })
  }
}
